<template>
  <router-view></router-view>
</template>

<script>
import {
  setSupplierTitleInfo,
  getSupplierTitleInfo,
} from "common/js/storage";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      labelLogo: ''
    }
  },
  created() {
    this.basicInformation();
  },
  methods: {
    // 获取基础信息
    basicInformation() {
      supplier.getXBBasicInformation().then((res) => {
        if (res.success) {
          this.labelLogo = res.result.labelLogo;
          document.querySelector('title').innerHTML = res.result.mallName;
          setSupplierTitleInfo(res.result);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
</style>
